import React from 'react'
import { useNavigate } from 'react-router-dom'

import { Button, useMediaQueryContext, useModalContext } from '@fourthwall/components'
import { reverse, routing } from '@utils/routing'

import { useThemeFeatureQuery } from '../../../../../queries/useThemeFeatureQuery'
import { useCurrentShop } from '../../../hooks/useCurrentShop'
import { BundleFeatureModal } from './modules/BundleFeatureModal/BundleFeatureModal'
import { useOfferBundleCreationMutation } from './queries/useOfferBundleCreationMutation'

interface CreateBundleProductButtonProps {
  onSuccess: () => void
}

export const CreateBundleProductButton = ({ onSuccess }: CreateBundleProductButtonProps) => {
  const navigate = useNavigate()
  const { tablet } = useMediaQueryContext()
  const { currentShop } = useCurrentShop()
  const { themeFeatureQuery } = useThemeFeatureQuery([
    { shop_id: currentShop?.id!, shop_theme_id: 'main', feature: 'bundles' },
  ])
  const { open } = useModalContext()

  const isBundleFeatureEnabled = themeFeatureQuery.data?.enabled

  const { offerBundleCreationMutation } = useOfferBundleCreationMutation({
    onSuccess: ({ id }) => {
      onSuccess()

      navigate(
        `${reverse(routing.products.bundle.bundleId.self, { bundleId: id })}${location.search}`,
      )
    },
  })

  return (
    <Button
      fullWidth={!tablet}
      label="Create bundle product"
      loading={offerBundleCreationMutation.isLoading || offerBundleCreationMutation.isSuccess}
      disabled={offerBundleCreationMutation.isLoading || offerBundleCreationMutation.isSuccess}
      size="xsmall"
      onClick={async () => {
        if (isBundleFeatureEnabled) {
          await offerBundleCreationMutation.mutateAsync([])
        } else {
          open(BundleFeatureModal)
        }
      }}
    />
  )
}
